// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"79d4c1d8","571":"f22fd382","680":"6203c4ef"}[chunkId] + ".chunk.js";
};